import { ChangeAlertCallbackType } from "../components/Root";
import { getPosition } from "./PositionService";
import * as API from '../http/api';

export class CommonService {
    private changeAlert: ChangeAlertCallbackType
    constructor(changeAlert: ChangeAlertCallbackType) {
        this.changeAlert = changeAlert
    }

    async getCatalog(data) {
        const pos = getPosition();
        const response = await API.service('getCatalog', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async csvToJson(data, props, type?) {
        const pos = getPosition();
        const request = {
            data: data,
            props: props,
            type: type
        }
        const response = await API.service('csvToJson', request, pos, this.changeAlert, null, null);

        return response?.data
    }

    async simpleCsvToJson(data) {
        const pos = getPosition();
        const response = await API.service('simpleCsvToJson', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async downloadFile(data) {
        const pos = getPosition();
        const response = await API.service('downloadFile', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async uploadBucketFile(data) {
        const pos = getPosition();
        const response = await API.service('uploadBucketFile', data, pos, this.changeAlert, null, null);

        return response?.data
    }
}